import { observable } from 'mobx'

import Store from '../shared/store'
import { apiStore } from '../shared/api'
import { apiClient } from '../shared/api-impl'

import { settings as config } from '../config'

import Settings from './model'

@apiStore(apiClient)
class SettingsStore extends Store {

  @observable loading = false

  @observable collection = []

  @observable current = null

  constructor(opts = {}) {

    super(opts)

    this.Model = Settings

    this.initAPIStore({
      ...opts,
      api: config.api,
    })

  }

  load(...args) {
    return this.api.load(...args)
  }

  save(...args) {
    return this.api.save(...args)
  }

  destroy(...args) {
    return this.api.destroy(...args)
  }

}

export const settingsStore = new SettingsStore()



// WEBPACK FOOTER //
// ./src/settings/store.js